import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-alerts-page',
    templateUrl: './alerts-page.component.html',
    styleUrls: ['./alerts-page.component.scss']
})
export class AlertsPageComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}
